import { Add, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";

export const ConfigDistribution = ({
  almacenes,
  almaSelected,
  distributionConfig,
  setDistributionConfig,
  clientes,
  partes,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleAddDistribution = (index) => {
    let newDistribution = {
      pp_alma_id: almaSelected[index].id,
      emp_id: null,
      part_id: null,
      pp_alma_item_proridad: null,
      pp_alma_item_racks: null,
    };
    let distributionData = { ...distributionConfig };
    distributionData[index].distribucion.push(newDistribution);
    setDistributionConfig(distributionData);
  };
  const handleChangeDistribution = (value, name, alma_index, distIndex) => {
    console.log(value, name, alma_index, distIndex);
    let distribution = { ...distributionConfig };
    if (name === "emp_id") {
      distribution[alma_index].distribucion[distIndex]["part_id"] = null;
      distribution[alma_index].distribucion[distIndex][name] = value;
    } else if (name === "pp_alma_item_racks") {
      const maxRacks = almaSelected[alma_index].maxRacks;
      let totalRacks = distribution[alma_index].distribucion.reduce(
        (total, dist, index) => {
          return total + (+dist.pp_alma_item_racks || 0);
        },
        0,
      );
      totalRacks =
        totalRacks -
        (+distribution[alma_index].distribucion[distIndex][name] || 0);
      const newTotalRacks = totalRacks + (+value || 0);
      if (newTotalRacks > maxRacks) {
        enqueueSnackbar(
          "La cantidad de racks excede el límite permitido para esta línea, favor de verificar",
          {
            autoHideDuration: 2000,
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          },
        );
      } else {
        distribution[alma_index].distribucion[distIndex][name] = value;
      }
    } else {
      distribution[alma_index].distribucion[distIndex][name] = value;
    }
    setDistributionConfig(distribution);
  };
  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <Grid container spacing={0} gap={2}>
      {almaSelected.map((alma, index) => (
        <Grid item xs={12} className="center_item">
          <Accordion sx={{ width: "100%", borderRadius: "8px" }} key={alma.id}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`alma-${alma.id}-panel1-content`}
              id={`alma-${alma.id}-panel1-header`}
              sx={{
                width: "100%",
                backgroundColor: "#f0f0f0",
                border: "2px solid #bcbcbc",
                borderRadius: "8px",
              }}
            >
              <Typography component="span">{`${alma.label} - ${alma.secuencial ? "Secuencial" : "No Secuencial"} ${alma.maxRacks ? `- Máximo ${alma.maxRacks} racks` : ""}`}</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                borderBottomRightRadius: "10px",
                borderBottomLeftRadius: "10px",
              }}
            >
              <Grid container spacing={0} gap={2}>
                <Grid
                  item
                  xs={12}
                  className="center_item"
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    onClick={() => handleAddDistribution(index)}
                    endIcon={<Add />}
                    sx={{
                      background: "#575E3B",
                      borderRadius: 2,
                      px: 4,
                      py: 1.2,
                      fontWeight: 700,
                      fontSize: 14,
                      textTransform: "none",
                      boxShadow: `0 4px 14px #575E3B44`,
                      "&:hover": {
                        background: "#40442d",
                        boxShadow: `0 6px 18px #575E3B55`,
                      },
                    }}
                  >
                    Nuevo registro
                  </Button>
                </Grid>
                {distributionConfig[index].distribucion.map(
                  (dist, distIndex) => (
                    <Grid item xs={12} className="center_item">
                      <Grid container spacing={0}>
                        <Grid item xs={2} className="center_item" sx={{ p: 1 }}>
                          <TextField
                            id="prioridad_racks"
                            label={alma.secuencial ? "Prioridad" : "Racks"}
                            name="prioridad_racks"
                            fullWidth
                            size="small"
                            value={
                              alma.secuencial
                                ? dist.pp_alma_item_proridad
                                : dist.pp_alma_item_racks
                            }
                            onChange={(e) =>
                              handleChangeDistribution(
                                e.target.value,
                                alma.secuencial
                                  ? "pp_alma_item_proridad"
                                  : "pp_alma_item_racks",
                                index,
                                distIndex,
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                          <Autocomplete
                            fullWidth
                            id="emp_id"
                            getOptionLabel={(opcion) => opcion.label}
                            filterSelectedOptions
                            options={clientes}
                            onKeyDown={handleKeyUp}
                            onChange={(e, newValue) =>
                              handleChangeDistribution(
                                newValue?.value || null,
                                "emp_id",
                                index,
                                distIndex,
                              )
                            }
                            renderOption={(props, option) => (
                              <Box {...props} key={option?.value}>
                                {option.label}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Cliente"
                                size="small"
                                fullWidth
                                required
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={5} className="center_item" sx={{ p: 1 }}>
                          <Autocomplete
                            fullWidth
                            id="part_id"
                            getOptionLabel={(opcion) =>
                              opcion?.codigo !== undefined
                                ? `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}`
                                : opcion?.label
                            }
                            filterSelectedOptions
                            options={partes.filter(
                              (part) => part.emp_id === dist.emp_id,
                            )}
                            disabled={!dist.emp_id}
                            onKeyDown={handleKeyUp}
                            onChange={(e, newValue) =>
                              handleChangeDistribution(
                                newValue?.value || null,
                                "part_id",
                                index,
                                distIndex,
                              )
                            }
                            renderOption={(props, option) => (
                              <Box {...props} key={option?.value}>
                                {option?.codigo !== undefined ? (
                                  option?.codigo
                                ) : (
                                  <></>
                                )}{" "}
                                /
                                {option?.codigo_salida !== undefined ? (
                                  option?.codigo_salida
                                ) : (
                                  <></>
                                )}{" "}
                                /
                                {option?.codigo_alterno !== undefined ? (
                                  option?.codigo_alterno
                                ) : (
                                  <></>
                                )}{" "}
                                / {option?.label}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Parte"
                                size="small"
                                fullWidth
                                required
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ),
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
      ))}
    </Grid>
  );
};
